import { ProcessorSwitch } from '../../../atoms/processor-switch';
import { NoPaymentsHookJustifi } from './no-payments-hook-justifi';
import { NoPaymentsHookStripe } from './no-payments-hook-stripe';

export const NoPaymentsHook = () => {
  return <ProcessorSwitch stripeContent={NoPaymentsHookStripe} justifiContent={NoPaymentsHookJustifi} />;
};
